import React, { useState } from 'react';
import { Newspaper, Mail } from 'lucide-react';
import NewsManagementPage from './NewsManagementPage';
import NewsletterPage from './NewsletterPage';
import HubShell from '../../components/staff/HubShell';

/**
 * Content Hub — bundles News (announcements) and Newsletter (email campaigns).
 * Same authors, same audience — one workspace.
 */
const ContentHubPage = (props) => {
  const [tab, setTab] = useState('news');
  const tabs = [
    { id: 'news', label: 'News & Announcements', icon: Newspaper, desc: 'Public stories and internal announcements', visible: true },
    { id: 'newsletter', label: 'Newsletter', icon: Mail, desc: 'Email campaigns', visible: true },
  ];

  return (
    <HubShell
      title="Content"
      accent="Hub"
      subtitle="Craft the stories your audience sees — everywhere."
      icon={Newspaper}
      tone="cyan"
      tabs={tabs}
      activeTab={tab}
      onTabChange={setTab}
      dataTestId="content-hub"
    >
      {tab === 'news' && <NewsManagementPage {...props} />}
      {tab === 'newsletter' && <NewsletterPage {...props} />}
    </HubShell>
  );
};

export default ContentHubPage;
